import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const SpeakersUIContext = createContext();

export function useSpeakersUIContext() {
  return useContext(SpeakersUIContext);
}

export function SpeakersUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async query => {
    const q = query.slice(1);
    api
      .get(`/adminPanel/speakers?sort=number_of_events&${q}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <SpeakersUIContext.Provider value={value}>{children}</SpeakersUIContext.Provider>;
}
